// extracted by mini-css-extract-plugin
module.exports = {"card":"plain-card_card__2WOg2","secondary":"plain-card_secondary__c_At2"};